export const PRODUCT_FAMILY_SA = 'SA';
export const PRODUCT_FAMILY_DEALSHIELD = 'DS';
export const PRODUCT_FAMILY_ALL = 'ALL';

export const PRODUCT_FAMILY_DISPLAY_NAMES = {
  [PRODUCT_FAMILY_SA]: 'Seller Guarantee',
  [PRODUCT_FAMILY_DEALSHIELD]: 'DealShield',
  [PRODUCT_FAMILY_ALL]: 'All Products',
};

export const PRODUCT_FAMILY_OPTIONS = [
  {
    key: PRODUCT_FAMILY_SA,
    value: PRODUCT_FAMILY_SA,
    text: PRODUCT_FAMILY_DISPLAY_NAMES[PRODUCT_FAMILY_SA],
  },
  {
    key: PRODUCT_FAMILY_DEALSHIELD,
    value: PRODUCT_FAMILY_DEALSHIELD,
    text: PRODUCT_FAMILY_DISPLAY_NAMES[PRODUCT_FAMILY_DEALSHIELD],
  },
  {
    key: PRODUCT_FAMILY_ALL,
    value: PRODUCT_FAMILY_ALL,
    text: PRODUCT_FAMILY_DISPLAY_NAMES[PRODUCT_FAMILY_ALL],
  },
];

export const DEFAULT_PRODUCT_FAMILY = PRODUCT_FAMILY_SA;

export const GUARANTEE_PRODUCT_LIST = PRODUCT_FAMILY_OPTIONS.map(opt => ({
  categoryCode: opt.value,
  displayName: opt.text,
}));

export const getProductType = productName => {
  if (!productName) return 'dealshield';
  const lowerName = productName.toLowerCase();
  if (lowerName.includes('all products')) return 'all-products';
  if (
    lowerName.includes('seller guarantee')
    || lowerName.includes('guarantee')
    || lowerName.includes('seller assurance')
    || lowerName.includes('assurance')
  ) {
    return 'seller-assurance';
  }
  return 'dealshield';
};
